import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { CASE_COUNT_WEEK_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData, getInputParams } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import { makeInteger } from '../../../utils.js'
import { Link } from 'react-router-dom'

const CASE_COUNT_WEEK = gql(CASE_COUNT_WEEK_QUERY)

export default function CaseCountWeekReport({ location }) {
  console.log('CaseCountWeekReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const inputs = getInputParams(location)
  console.log(inputs)
  const title = inputs.byFirm ? 'Weekly Totals By Firm' : 'Weekly Complaint Entry Totals'

  useEffect(() => {
    getData(location, CASE_COUNT_WEEK, 'caseCountWeekReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    let total = 0
    let totalColumn = inputs.byFirm ? 3 : 2
    const resultRows = []
    for (let i = 0; i < results.reportData.length; i++) {
      const row = []
      for (let j = 0; j < results.reportData[i].length; j++) {
        if (j === 1) {
          let inFirm = ''
          if (inputs.byFirm) {
            inFirm = encodeURIComponent(results.reportData[i][2])
          }
          row.push(<td key={j} align='center'><Link to={`/custom/caseCountDetails?inputs=${JSON.stringify({year: results.reportData[i][0], week: results.reportData[i][j], level: 'DETAIL', firm: inFirm} ) } ` } target="_blank">{results.reportData[i][j]}</Link></td>)
        } else if (j === totalColumn) {
          total += makeInteger(results.reportData[i][j])
          row.push(<td key={j} align='right'>{results.reportData[i][j]}</td>)
        } else {
          row.push(<td key={j}>{results.reportData[i][j]}</td>)
        } 
      }
      resultRows.push(<tr key={i}>{row}</tr>)
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/caseCountWeekReport/case_count_week_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{width: 'auto', margin: 'auto'}}>
          <ReportHeading title={title} widths={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
            <tr key={'totals'}>
              <td colSpan={totalColumn} style={{ textAlign: 'right', fontWeight: 'bold' }}>Grand Total</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{total}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    )
  }
}